import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/style.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vuescroll from "vuescroll";

import AOS from "aos";
import "aos/dist/aos.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//FontAwsome
library.add(faUserSecret);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("scrollbar", vuescroll);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    let language = to.params.lang;
    if (!language) {
        language = 'en'
    }
    i18n.locale = language
    next()
});

Vue.mixin({
    methods: {
        counterAnimation() {
            var counter = gsap.utils.toArray(".counter");
            counter.forEach(count => {
                var target = { val: 0 },
                    number = count.dataset.number,
                    split = (number + "").split("."),
                    decimals = split.length > 1 ? split[1].length : 0;

                gsap.to(target, {
                    duration: 2,
                    val: number,
                    ease: "none",
                    roundProps: "innerText",
                    onUpdate: function() {
                        const val = gsap.getProperty(count, "innerText");
                        count.innerText = target.val.toFixed(decimals);
                    },
                    scrollTrigger: {
                        trigger: count,
                        start: "top bottom",
                        scrub: false,
                        markers: false
                    }
                });
            });
        }
    }
});

new Vue({
    router,

    created() {
        AOS.init({
            offset: 50,
        });
    },

    i18n,
    render: h => h(App)
}).$mount("#app");